module.exports = __webpack_public_path__ + "images/9b3dd96ad00c00ba36feac6245800e5b-logo.png";